import { render } from "./sellingProduct.vue?vue&type=template&id=1c525e24"
import script from "./sellingProduct.vue?vue&type=script&lang=js"
export * from "./sellingProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__